/**
 * Buyer ID Obfuscation Utilities
 * Used to encode/decode buyer IDs in URLs to 16-character dynamic strings.
 */

export const encodeBuyerId = (id) => {
    if (!id) return '';
    const n = parseInt(id);
    // Use multiplication and XOR with reverse to make it look like a unique hash
    const p1 = (n * 1357924).toString(16).padStart(8, '0');
    const p2 = (n ^ 0x5A5A5A5A).toString(16).padStart(8, '0');
    return (p1 + p2).split('').reverse().join('').toUpperCase();
};

export const decodeBuyerId = (encoded) => {
    if (!encoded || encoded.length !== 16) return null;
    try {
        const s = encoded.toLowerCase().split('').reverse().join('');
        const p1 = s.substring(0, 8);
        const id = Math.round(parseInt(p1, 16) / 1357924);
        return (id > 0 && isFinite(id)) ? id : null;
    } catch (e) {
        return null;
    }
};
